import React, { useMemo } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';

import { Box, Card, CardContent, List, Typography } from '@material-ui/core';
import Container from 'src/components/Layouts/Container';
import useFetch from 'src/hooks/useFetch';

import { PIX_ENABLED } from 'src/consts/common';

import { useStyles } from './styles';
import PaymentItem from './PaymentItem';

export function FormasPagamento() {
  const classes = useStyles();

  const history = useHistory();
  const { state } = useLocation();
  const { id } = useParams();

  const [servicos, isLoading, isError] = useFetch('/servicos');
  const servico = useMemo(() => {
    if (Array.isArray(servicos)) {
      const servicoAtualizado = servicos.find(
        (servicoItem) => String(servicoItem.id) === String(id)
      );

      if (servicoAtualizado) {
        return servicoAtualizado;
      }
    }

    return state?.servico || null;
  }, [id, servicos, state]);

  const handleContratarClick = ({ title, parcela, valorParcela }) => {
    if (!servico) return;

    if (title.includes('CARTÃO')) {
      history.push({
        pathname: '/PagamentoComCartao',
        state: {
          type: 'SERVICO',
          isOpeningCompany: false,
          plano: {
            ...servico,
            parcela,
            valorParcela,
          },
        },
      });
    } else if (title.includes('PIX')) {
      history.push({
        pathname: '/PagamentoComPix',
        state: {
          type: 'SERVICO',
          plano: {
            ...servico,
            parcela,
            valorParcela,
          },
        },
      });
    } else {
      history.push({
        pathname: '/PagamentoComBoleto',
        state: {
          type: 'SERVIÇOS',
          plano: {
            ...servico,
            parcela,
            valorParcela,
          },
        },
      });
    }
  };

  return (
    <Container isLoading={isLoading} isError={isError}>
      <Box className={classes.root}>
        <Card variant="outlined">
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              Formas de pagamento
            </Typography>
          </CardContent>
          <List className={classes.list}>
            {servico?.servico_forma_pagamento?.length > 0 &&
              servico.servico_forma_pagamento
                .filter(
                  ({ forma_de_pagamento }) =>
                    PIX_ENABLED || !forma_de_pagamento.descricao.includes('PIX')
                )
                .map(({ id: paymentId, forma_de_pagamento }) => (
                  <PaymentItem
                    key={paymentId}
                    formaPagamento={forma_de_pagamento}
                    valor={servico.valor}
                    onClick={handleContratarClick}
                  />
                ))}
          </List>
        </Card>
      </Box>
    </Container>
  );
}

export default FormasPagamento;
